import { render, staticRenderFns } from "./ElementGenerator.vue?vue&type=template&id=3fac7b77"
import script from "./ElementGenerator.vue?vue&type=script&lang=ts"
export * from "./ElementGenerator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports